import { WebhookEventsEnum } from '../enums';

export interface IWebhookInputTestDto {
    url: string;
    secret?: string;
    event: WebhookEventsEnum;
}
